(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["avatars"] = factory();
	else
		root["avatars"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 